/**
 * When something that has to be made will be ready: the longest "days to
 * make" among what's needed, counted from today. Products made at the same
 * time finish when the slowest one does.
 */

/**
 * The estimated ready date for work needing these products.
 * @param daysToMake - Each needed product's days to make (unset ones ignored)
 * @param from - When the work starts (defaults to now)
 * @returns The date, or null when none of them says how long it takes
 */
export function estimateReadyDate(
  daysToMake: readonly (number | null | undefined)[],
  from: Date = new Date(),
): Date | null {
  const known = daysToMake.filter(
    (d): d is number => typeof d === 'number' && d >= 0,
  );
  if (known.length === 0) return null;
  const ready = new Date(from);
  ready.setHours(0, 0, 0, 0);
  ready.setDate(ready.getDate() + Math.max(...known));
  return ready;
}
